/**
 * CD-8740 — which "session epoch" is the SPA in?
 *
 * The boot session probe can settle long after first paint (it keeps running
 * once `BOOT_PROBE_TIMEOUT_MS` has let the app render). By then the user may
 * have signed in or out, and the probe's result describes a session that no
 * longer exists: a late 401 would wipe the new session, a late success would
 * start a second refresh loop or undo a sign-out.
 *
 * The probe reads the generation when it starts and discards its result if the
 * generation has moved. The login saga advances it on every event that changes
 * who is signed in (sign-in, sign-up, sign-out, local teardown).
 */
let generation = 0;

/** The current generation. Compare, never interpret. */
export const currentSessionGeneration = (): number => generation;

/** Record that the signed-in user has changed, invalidating anything in flight. */
export const bumpSessionGeneration = (): number => {
  generation += 1;
  return generation;
};
